import { PM2ActivityIcon, PM2LibraryIcon, PM2ImageIcon, PM2LightBulbIcon, PM2InteractiveToolIcon, PM2DownloadIcon, PM2TargetWithArrowIcon, PM2BookIcon, PM2FactIcon, PM2CourseIcon, PM2ParentIcon, PM2CraftsIcon, PM2WhiskerIcon, PM2ChefsHatIcon, PM2GlobeIcon, PM2BuildingIcon, PM2LinkIcon, PM2AudioIcon, PM2AppleIcon, PM2TargetIcon, PM2NotebookIcon, PM2CheckmarkIcon, PM2EncyclopediaIcon, PM2MovementIcon, PM2ToolIcon, PM2ReligionIcon, PM2BroccoliIcon, PM2TableLampIcon, PM2ABCIcon, PM2TextIcon, PM2TextWithAudioSpeakerIcon, PM2DirectionSignsIcon, PM2AnimationIcon, PM2ReadingGuideIcon, PM2HandIcon, PM2PuzzleIcon, PM2BrainIcon, PM2VideoIcon, PM2TwoPointOIcon, PM2InfoIcon, PM2ReadMoreIcon, PM2SentenceIcon, PM2WrittenAssignmentIcon, PM2GameIcon, PM2GeogebraIcon, PM2OralAssignmentIcon, PM2GpsIcon, PM2DefinitionIcon, PM2TeacherWithStudentsIcon, PM2ProofIcon, PM2QuoteIcon, PM2PairIcon, PM2GroupIcon, PM2IndividualIcon, PM2TeacherWithBoardIcon, PM2ArchiveIcon, PM2ExampleIcon, PM2TextWithAudioIcon, PM2StudentIcon, PM2NatureIcon, PM2TeacherIcon } from '@ui/kit';
import { jsx } from 'react/jsx-runtime';

function Pm2Icon(props) {
  const renderIcon = ICON_MAPPING.get(ICON_ALIAS_MAPPING.get(props.ident) ?? props.ident);
  if (!renderIcon) {
    if (!MISSING_IDENT_WARNINGS.has(props.ident)) {
      console.warn("renderPm2Icon(): Unknown icon ident '\\u%s'", props.ident.charCodeAt(0).toString(16).padStart(4, "0"), props.ident);
      MISSING_IDENT_WARNINGS.add(props.ident);
    }
    return null;
  }
  return renderIcon({
    size: props.size,
    strokeWidth: props.strokeWidth
  });
}
const MISSING_IDENT_WARNINGS = new Set();
const ICON_MAPPING = new Map([["aktivitet-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ActivityIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["bibliotek-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2LibraryIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["billede-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ImageIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["design-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2LightBulbIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["digitalt-redskab-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2InteractiveToolIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["dokument-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2DownloadIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["evaluering-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TargetWithArrowIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["fagboeger-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2BookIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["fakta-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2FactIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["forloeb-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2CourseIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["foraeldre-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ParentIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["haandvaerk-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2CraftsIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["kogebog-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2WhiskerIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["kokkeskole-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ChefsHatIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["kultur-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2GlobeIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["lander-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2BuildingIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["link-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2LinkIcon, {
  height: size,
  width: size,
  strokeWidth: strokeWidth
})], ["lyd-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2AudioIcon, {
  height: size,
  width: size,
  strokeWidth: strokeWidth
})], ["laerer-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2AppleIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["maal-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TargetIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["notesbog-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2NotebookIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["opgave-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2CheckmarkIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["opslagsvaerk-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2EncyclopediaIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["overgange-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2MovementIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["redskaber-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ToolIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["religionerne-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ReligionIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["raavarer-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2BroccoliIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["spotpaa-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TableLampIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["sprog-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ABCIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["tekst-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TextIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["tekst-med-lyd-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TextWithAudioSpeakerIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["valgfag-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2DirectionSignsIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["video-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2AnimationIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["laeseguide-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ReadingGuideIcon, {
  height: size * 1.4,
  strokeWidth: strokeWidth
})], ["hand-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2HandIcon, {
  height: size * 1.3,
  strokeWidth: strokeWidth
})],
// unnamed icons
["\u20aa", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2PuzzleIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20ab", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2BrainIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20ae", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2VideoIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20af", ({
  size
}) => /*#__PURE__*/jsx(PM2TwoPointOIcon, {
  height: size * 0.6
})], ["\u20b2", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2InfoIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20b4", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ReadMoreIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20a5", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2SentenceIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20a6", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2WrittenAssignmentIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20a7", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2GameIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u007b", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2GeogebraIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u007e", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2OralAssignmentIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u00a3", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2GpsIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u00a4", ({
  size
}) => /*#__PURE__*/jsx(PM2DefinitionIcon, {
  height: size * 0.6
})], ["\u20b1", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TeacherWithStudentsIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u00a7", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ProofIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u006c", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2QuoteIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u006f", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2PairIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u0070", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2GroupIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u0071", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2IndividualIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u0072", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TeacherWithBoardIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u20b3", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2ArchiveIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["\u006a", ({
  size
}) => /*#__PURE__*/jsx(PM2ExampleIcon, {
  height: size * 0.7
})], ["\u20a9", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TextWithAudioIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["elev-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2StudentIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["natur-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2NatureIcon, {
  height: size,
  strokeWidth: strokeWidth
})], ["underviser-icon", ({
  size,
  strokeWidth
}) => /*#__PURE__*/jsx(PM2TeacherIcon, {
  height: size,
  strokeWidth: strokeWidth
})]]);
const ICON_ALIAS_MAPPING = new Map([["til-laereren-icon", "laerer-icon"], ["traening-icon", "opgave-icon"], ["\u0021", "digitalt-redskab-icon"], ["\u0037", "digitalt-redskab-icon"], ["\u0039", "digitalt-redskab-icon"], ["\u003b", "digitalt-redskab-icon"], ["\u00f8", "digitalt-redskab-icon"], ["\u2128", "digitalt-redskab-icon"], ["\u0026", "evaluering-icon"], ["\u0029", "evaluering-icon"], ["evaluering", "evaluering-icon"], ["\u002a", "aktivitet-icon"], ["\u002b", "aktivitet-icon"], ["\u0045", "aktivitet-icon"], ["\u003e", "billede-icon"], ["\u0052", "billede-icon"], ["\u0056", "lyd-icon"], ["\u006b", "fakta-icon"], ["faktaboks", "fakta-icon"], ["\u00b4", "overgange-icon"], ["bevaegelse", "overgange-icon"], ["\u00bd", "laerer-icon"], ["laerevejledning", "laerer-icon"], ["\u040e", "maal-icon"], ["\u0058", "video-icon"], ["\u005f", "video-icon"], ["\u0059", "tekst-icon"], ["\u005c", "opgave-icon"], ["\u007c", "opgave-icon"], ["opgave", "opgave-icon"], ["\u2663", "hand-icon"], ["aktivitet", "hand-icon"], ["\u2665", "laeseguide-icon"], ["laeseguide", "laeseguide-icon"], ["citat", "\u006c"], ["eksempel", "\u006a"], ["mundtlig-opgave", "\u007e"], ["maal", "maal-icon"], ["opgave-gruppe", "\u0070"], ["opgave-individuel", "\u0071"], ["opgave-klasse", "\u20b1"], ["opgave-par", "\u006f"], ["skriftlig-opgave", "\u20a6"], ["spil", "\u20a7"], ["udfordringsopgave", "\u20aa"], ["undersoegelse-eksperiment", "\u20ab"], ["\u20b5", "\u20b2"], ["\u03fc", "\u20b1"], ["\u00a5", "\u00a7"]]);

export { ICON_ALIAS_MAPPING, ICON_MAPPING, Pm2Icon };
//# sourceMappingURL=icon.js.map
